import * as React from "react";

function SvgCheckmarkInEmptyCircle(props) {
  return <svg width={40} height={40} viewBox="0 0 40 40" fill="none" {...props}><path d="M12 22.13L17.333 27 28 11" stroke="currentColor" strokeWidth={2} /><circle cx={20} cy={20} r={19} stroke="currentColor" strokeWidth={2} /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/checkmark-in-empty-circle_205343.svg";
export { SvgCheckmarkInEmptyCircle as ReactComponent };